export const enum BehaviorType {
  WEAK = 'weak',
  NEUTRAL = 'neutral',
  STRONG = 'strong',
}
